module.exports = __webpack_public_path__ + "img/settings.f24fc616.svg";